import * as Yup from 'yup';
import isEmailValidator from 'validator/lib/isEmail';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { salesforceCountyOptionsByCountry, validatePostCode } from '../../helpers/helpers';
import countries from '../../helpers/hardcodedCountries';

export const locations1validationSchema = Yup.object({
  name: Yup.string().required('validation.fieldRequired').max(50, 'validation.lessThan50Chars'),
  description: Yup.string().max(50, 'validation.lessThan50Chars'),
  addressLine1: Yup.string()
    .required('validation.fieldRequired')
    .max(50, 'validation.lessThan50Chars'),
  address2: Yup.string().max(50, 'validation.lessThan50Chars'),
  town: Yup.string().required('validation.fieldRequired').max(50, 'validation.lessThan50Chars'),
  county: Yup.string()
    .max(50, 'validation.lessThan50Chars')
    .test('county', 'validation.fieldRequired', function (value) {
      const { country } = this.parent;
      const newCountyList = salesforceCountyOptionsByCountry(country);

      return (newCountyList?.length > 0 && value !== '') || newCountyList.length < 1;
    }),
  country: Yup.string().required('validation.fieldRequired').max(50, 'validation.lessThan50Chars'),
  postCode: Yup.string()
    .required('validation.fieldRequired')
    .test('postCode', 'validation.invalidPostCode', function (value) {
      const { country } = this.parent;
      return validatePostCode(value, country);
    }),
});

export const locations2ValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .max(50, 'validation.lessThan50Chars')
    .required('validation.fieldRequired'),
  description: Yup.string().trim().max(50, 'validation.lessThan50Chars'),
  addressLine1: Yup.string()
    .trim()
    .max(50, 'validation.lessThan50Chars')
    .required('validation.fieldRequired'),
  address2: Yup.string().trim().max(50, 'validation.lessThan50Chars'),
  town: Yup.string()
    .trim()
    .max(50, 'validation.lessThan50Chars')
    .required('validation.fieldRequired'),
  country: Yup.string()
    .trim()
    .max(50, 'validation.lessThan50Chars')
    .required('validation.fieldRequired'),
  county: Yup.string()
    .max(50, 'validation.lessThan50Chars')
    .test('county', 'validation.fieldRequired', function (value) {
      const { country } = this.parent;
      const newCountyList = salesforceCountyOptionsByCountry(country);

      return (newCountyList?.length > 0 && value !== '') || newCountyList.length < 1;
    }),
  postCode: Yup.string()
    .trim()
    .max(10, 'validation.lessThan10Chars')
    .required('validation.fieldRequired')
    .test('postCode', 'validation.invalidPostCode', function (value) {
      const country = this.parent.countryName;
      return validatePostCode(value, country);
    }),
  phoneNumber: Yup.string()
    .min(5, 'validation.invalidPhoneNumber')
    .max(50, 'validation.lessThan50Chars')
    .required('validation.fieldRequired')
    .test(
      'is-valid',
      'validation.invalidPhoneNumber',
      (value) => value && isValidPhoneNumber(value)
    ),
  emailAddress: Yup.string()
    .max(50, 'validation.lessThan50Chars')
    .required('validation.fieldRequired')
    .test('is-valid', 'validation.validEmail', (value) =>
      value ? isEmailValidator(value) : false
    ),
});
